var map = {
	"./1.jpg": 2230,
	"./10.jpg": 2231,
	"./2.jpg": 2232,
	"./3.jpg": 2233,
	"./4.jpg": 2234,
	"./5.jpg": 2235,
	"./6.jpg": 2236,
	"./7.jpg": 2237,
	"./8.jpg": 2238,
	"./9.jpg": 2239
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2229;